<template>
    <div class="container">
        <div>
            <essentialPCb v-if="isPC"/>
            <essentialH5b v-else/>
        </div>
    </div>
</template>

<script>

import essentialPCb from '../components/essentialPCbNew'
import essentialH5b from '../components/essentialH5bNew'
import { enableAppShare } from '../../../common/js/APP/share';
import { fetchQueryFNNew } from '@/service/api'
import { getCookie, setCookie } from '../../../uitl/getParam.js';
export default {
    components: {
        essentialH5b,
        essentialPCb
    },
    // mixins: [common],
    data() {
        return {
            isBView:'A',//A版      B版
            current: 0,
            modalVisible: false,
            sortStageList: [],
        };
    },
    computed: {

    },
    mounted() {
        enableAppShare({
            title: '前端必学的技能手册',
            desc: '企业级项目实操实练，0 基础进阶高级前端开发',
            imgUrl: 'https://s21.lgstatic.com/growth/activity/20210415/1618467769361.jpeg'
        });
        // this.getPageFn()
    },
    methods: {
        getPageFn() {
            const page_key = 'FE_ESSENTIAL';
            if (!this.isApp) {
                let page = JSON.parse(getCookie(page_key));
                if (!page) {
                    page = {}
                    page.pageType = Math.ceil(Math.random() * 2)
                    setCookie(page_key, JSON.stringify(page))
                }
                this.isBView = page.pageType == 2 ? 'B' : 'A';
                return
            }
            let params = {
                pageMark: page_key,//AI
            }
            fetchQueryFNNew(params).then(res => {
                if(res.state == 1) {
                    if(res.content) { //命中页面 不返回值
                        this.isBView = 'B';
                    } else { //未命中 走a版
                        this.isBView = 'A'
                    }
                } else {
                    this.isBView = 'A'  //默认a版  报错a版
                }
            }).catch(error => {
                this.isBView = 'A'  //默认a版  报错a版
            });
        },
    }
};
</script>

<style lang="less">
body, html {
    height: auto;
}
</style>
<style lang="less" scoped>
    .container {
        background: #F8F8F8;
    }
</style>